module.exports = __webpack_public_path__ + "static/mpg_logo_wide-5c6bceeecefeb2117b530b6e09e3802b.png";